import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import BooksStaffMenu from './components/BooksStaffMenu';

import {
  RealStaff,
  Staff,
  RandomStaff,
} from '../../../../../interfaces/merchants/resources/books';

interface StaffProps {
  random: boolean;
  staffs: RealStaff[];
  postable: boolean;
  onClick: (staff: Staff) => void;
}

type Props = StaffProps;

const InputBookingTargetStaffSelector: React.FC<Props> = (props) => {
  const handleChangeStaff = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const { staffs, onClick } = props;
      const {
        currentTarget: { value },
      } = e;

      if (value === '') {
        const randomStaff: RandomStaff = { id: '', query_id: '' };
        onClick(randomStaff);
        return;
      }

      const staff = staffs.find((s) => String(s.id) === value)!;
      onClick(staff);
    },
    [props],
  );

  const { random, staffs, postable } = props;
  const intl = useIntl();

  return (
    <div>
      {random && (
        // TODO: スタッフ指定しない動作要確認
        <BooksStaffMenu
          staffName={intl.formatMessage({ id: 'books.booksMenu.noSelect' })}
          postable={postable}
          onClick={handleChangeStaff}
        />
      )}
      {staffs.map((staff) => (
        <BooksStaffMenu
          key={staff.id}
          staffName={staff.name}
          staffImage={staff.image.url}
          staffID={staff.id}
          description={staff.description}
          postable={postable}
          onClick={handleChangeStaff}
        />
      ))}
    </div>
  );
};

export default InputBookingTargetStaffSelector;
